import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Gera o relatório em PDF
 *
 * @param {Array} cadastros
 * @param {*} equipe
 */
export function generatePdf(cadastros, equipe) {
  const titlePdf = 'Busca ativa cadastro'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, equipe.no_esf_eap)
  const descriptionPdf =
    'Cidadãos com atendimento recente e sem cadastro vinculado a eSF ou eAP'
  const headersPdf = ['NOME', 'NASCIMENTO', 'MÃE', 'CI', 'ACOMPANHAMENTO']

  const dataPdf = cadastros.map((item) => {
    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento:
        utils.methods.formatDate(item.dt_nascimento) +
        `\n(${item.idade} ${item.idade > 1 ? 'anos' : 'ano'})`,
      no_mae: item.no_mae,
      cadastro: item.dt_ultima_ficha
        ? `${utils.methods.formatDate(item.dt_ultima_ficha)}\n(${
            item.percent_fci_completa
          }%)`
        : '',
      dt_ultimo_acompanhamento: item.dt_ultimo_acompanhamento
        ? `${utils.methods.formatDate(item.dt_ultimo_acompanhamento)} (${
            item.tp_ultimo_acompanhamento
          })`
        : 'Sem atendimento',
      is_acompanhado: item.is_acompanhado,
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state?.infoMunicipio?.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: equipe.no_esf_eap },
        { label: 'CNES', value: equipe.nu_cnes },
        { label: 'INE', value: equipe.ine_esf_eap },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ section }) => {
          if (section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  CI: {
    callback: (item) => {
      let fci = `${
        item.dt_ultima_ficha != null
          ? utils.methods.formatDate(item.dt_ultima_ficha)
          : ''
      }\n(${item.percent_fci_completa ? item.percent_fci_completa + '%' : '%'})`
      return fci
    },
  },
  Acompanhamento: {
    callback: (item) => {
      if (item.dt_ultimo_acompanhamento == null) {
        return 'Sem atendimento'
      }
      let acompanhamento = `${utils.methods.formatDate(
        item.dt_ultimo_acompanhamento
      )}\n(${
        item.tp_ultimo_acompanhamento != null
          ? item.tp_ultimo_acompanhamento
          : ''
      })`
      return acompanhamento
    },
  },
}
